/**
 * GraphQL Main Index
 * Centralized export for all GraphQL operations
 */

// Import organized modules for convenience exports
import * as PermissionQueries from './queries/permissions';
import * as AuthQueries from './queries/auth';
import * as PermissionMutations from './mutations/permissions';
import * as AuthMutations from './mutations/auth';

// Export all queries
export * from './queries';

// Export all mutations  
export * from './mutations';

// Re-export organized by categories for convenience
export const Queries = {
  Permissions: PermissionQueries,
  Auth: AuthQueries,
};

export const Mutations = {
  Permissions: PermissionMutations,
  Auth: AuthMutations,
}; 